import _ from 'lodash';
import { Query } from './Query';
import { ParamableCollection } from './Collections/ParamableCollection';
import { Facet } from './Facets/Facet';
import { FacetGroup } from './Facets/FacetGroup';
import { SortBy } from './Sort/SortBy';
import { SingleSortOrder } from './Sort/SingleSortOrder';
import { RouteBuilder } from "./RouteBuilder";
import { Pager } from "./Pager";
import { AngularTransport } from "./HttpTransport/AngularTransport";

export class SearchServiceProvider {
    constructor() {
        this._config = {
            id: null,
            url: null,
            responseTransform: null,
            queryTransform: null,
			filters: []
    	};

		this.$get = ['$http', function(http) {
			var transport = new AngularTransport(http);
			return this.getService(transport);
		}];
    }


    getService(http) {
        return new SearchService(http, this._config);
    }

    getConfig() {
        return this._config;
    }

    setSearchId(id) {
        this._config.id = id;
        return this;
    }

    setUrl(url) {
        this._config.url = url;
        return this;
    }

    setFilters(filters) {
        this._config.filters = filters;
    }

    setResponseTransform(transformer) {
        this._config.responseTransform = transformer;
        return this;
    }

    setQueryTransform(transformer) {
        this._config.queryTransform = transformer;
        return this;
    }

    setHttpTransport(transport) {
    	this._transport = transport;
    }
}


class SearchService {
    constructor(httpTransport, config) {
        this._http = httpTransport;
        this._searchId = config.id;
        this._url = config.url;
        this._responseTransform = config.responseTransform;
        this._queryTransform = config.queryTransform;
        this._params = new ParamableCollection();
        this._routeBuilder = new RouteBuilder(this._params);
        this._pager = new Pager({});
        this._results = [];

        _.each(config.filters, filter => {
            this.addParamable(filter);
        });
    }


    getSearchId() {
        return this._searchId;
    }

    getUrl() {
        return this._url;
    }

     getFilters() {
        return this._params.filterByType('Filter');
    }

     getFacetGroups() {
        return this._params.filterByType('FacetGroup');
    }

    getFacetGroup(id) {
        return _.find(this._params.filterByType('FacetGroup'), { id: id });
    }

    getFacet(id) {
        var facet;
        _.some(this.getFacetGroups(), function(group) {
            facet = group.getFacet(id, true);
            return facet !== undefined;
        });

        return facet;

    }

     getSortByValue() {
        var sorters = this._params.filterByType('SortBy');
        return sorters[0].value;
    }

     getCurrentSortOrder() {
        var sorters = this._params.filterByType('SortOrder');
        return sorters[0].current;
    }


    getResults() {
    	return this._results;
    }

    getRouteBuilder() {
        return this._routeBuilder;
    }

    getPager() {
        return this._pager;
    }

    addFacetGroup(group) {
        this.addParamable(group);
    }


    selectFacet(facetId) {
        _.each(this.getFacetGroups(), group => {
            group.selectFacet(facetId, true);
        });
    }

    deselectFacet(facetId) {
        _.each(this.getFacetGroups(), group => {
           group.deselectFacet(facetId, true);
        });
    }

    toggleFacet(facetId) {
        _.each(this.getFacetGroups(), group => {
            group.toggleFacet(facetId, true);
        });
    }

    addFilter(filter) {
        this.addParamable(filter);
    }

    getFilter(filterId) {
        return _.find(this.getFilters(), { id: filterId });
    }

    setSort(sorter, order = new SingleSortOrder()) {
        this.addParamable(sorter);

        // implicitly create a SortOrder if none currently exists
        if (!this._params.filterByType('SortOrder').length) {
            this.addParamable(order);
        }
    }

    flipSortOrder() {
        var sorter = this._params.filterByType('SortOrder')[0];
        if (sorter) {
            sorter.flip();
        }
    }

    addParamable(paramable) {
        this._params.add(paramable);
    }

    query() {
        let query = new Query({
            url: this._url,
            transport: this._http,
            data: this._params.toHash()
        });

        if (typeof this._queryTransform === 'function') {
            query.beforeTransform = this._queryTransform;
        }

        if (typeof this._responseTransform === 'function') {
            query.afterTransform = this._responseTransform;
        }

        return query.exec().then( data => {
			if (data.hasOwnProperty("data")) {
				data = data.data;
			}
            this._processResults(data);
        });
    }

    _processResults(data) {
        this._results = data.results;
        this._pager = new Pager({
            current: data.request.page,
            perPage: data.results.length,
            totalResults: data.totalResults
        });

        _.each(data.facets, rawGroup => {
            this.addParamable(FacetGroup.buildFromJson(rawGroup));
        });
    }
}
